<template>
  <div>
    <div class="row">
      <button
        class="col-md-2 ml-1 mb-1 btn btn-success"
        @click="exportToExcel"
        style="white-space: nowrap"
      >
        <i class="fa fa-file-excel"></i> Exportar para Excel
      </button>
      <div class="col-md-12">
        <base-crud
          :ref="'unidadesCrud'"
          crudName="Unidades"
          newText="Novo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import $ from "jquery";

export default {
  data: function () {
    return {
      table: "unidadesTable",
      showMessageImport: false,
      unidadesCrud: {},
      pages: [],
      url: "",
      columns: ["id", "nome", "sigla", "tipo_servico", "rotas", "actions"],
      tableData: [
        "id",
        "unidade_id_pai",
        "nome",
        "sigla",
        "endereco",
        "bairro",
        "complemento",
        "cep",
        "ponto_referencia",
        "numero",
        "veiculo_id",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "nome", "sigla", "tipo_servico"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Nome da Unidade",
          sigla: "Sigla",
          tipo_servico: "Tipo de Serviço",
          rotas: "Rotas",
          actions: "Ações",
        },
        sortable: ["nome"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          tipo_servico: [
            {
              id: "TIH",
              text: "TIH",
            },
            {
              id: "SAMU",
              text: "SAMU",
            },
          ],
        },
        templates: {
          tipo_servico: function (h, row, index) {
            return row.tipo_servico || "Não informado";
          },
          rotas: function (h, row, index) {
            if (!row.rotas || row.rotas.length === 0) {
              return <span class="badge badge-secondary">Sem rotas</span>;
            }
            return (
              <div>
                {row.rotas.map((rota) => (
                  <span class="badge badge-primary mr-1 mb-1">{rota.nome}</span>
                ))}
              </div>
            );
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "unidades",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
        sigla: "sigla",
        tipo_servico: "tipo_servico",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    exportToExcel: function () {
      const self = this;

      // Pegar os filtros atuais da tabela
      const tableComponent = self.$refs.unidadesCrud;
      let currentQuery = {};

      if (
        tableComponent &&
        tableComponent.$refs.table &&
        tableComponent.$refs.table.query
      ) {
        currentQuery = tableComponent.$refs.table.query;
      }

      // Captura alternativa - verificar elementos do DOM diretamente
      if (Object.keys(currentQuery).length === 0) {
        console.log("⚠️ Tentando capturar filtros do DOM...");

        // Buscar elementos select com filtros
        const selectElements = document.querySelectorAll(
          '[name*="tipo_servico"], select[class*="filter"]'
        );
        selectElements.forEach((select) => {
          if (select.value && select.value !== "") {
            if (select.name.includes("tipo_servico")) {
              currentQuery["tipo_servico"] = select.value;
            }
          }
        });

        // Buscar inputs de texto com filtros
        const inputElements = document.querySelectorAll(
          'input[name*="nome"], input[name*="sigla"], input[name*="id"]'
        );
        inputElements.forEach((input) => {
          if (input.value && input.value.trim() !== "") {
            const fieldName = input.name.includes("nome")
              ? "nome"
              : input.name.includes("sigla")
              ? "sigla"
              : input.name.includes("id")
              ? "id"
              : null;
            if (fieldName) {
              currentQuery[fieldName] = input.value.trim();
            }
          }
        });
      }

      self.$loading(true);

      // Construir query string manualmente com os filtros
      let queryParams = new URLSearchParams();

      // Aplicar cada filtro individualmente
      if (currentQuery) {
        Object.keys(currentQuery).forEach((key) => {
          if (currentQuery[key] && currentQuery[key] !== "") {
            queryParams.append(key, currentQuery[key]);
            console.log(`🔍 Filtro capturado: ${key} = ${currentQuery[key]}`);
          }
        });
      }

      // Adicionar parâmetros para buscar TODOS os registros
      queryParams.append("export_all", "true");
      queryParams.append("limit", "10000");
      queryParams.append("per_page", "10000");

      let finalQuery = queryParams.toString();

      console.log("🔍 Filtros aplicados:", currentQuery);
      console.log("🔗 Query final:", finalQuery);
      console.log(
        "🔗 URL completa:",
        self.$store.state.api + "unidades?" + finalQuery
      );

      // Fazer requisição para buscar TODOS os dados filtrados
      axios
        .get(self.$store.state.api + "unidades?" + finalQuery)
        .then((response) => {
          self.$loading(false);

          const allData = response.data.data || [];

          console.log("📊 Total de registros recebidos:", allData.length);

          if (allData.length === 0) {
            self.$message(
              "Aviso",
              "Nenhum registro encontrado com os filtros aplicados.",
              "warning"
            );
            return;
          }

          // Criar JSON com apenas as colunas desejadas
          const jsonData = allData.map((item) => ({
            ID: item.id,
            Nome: item.nome || "Não informado",
            Sigla: item.sigla || "Não informado",
            "Tipo de Serviço": item.tipo_servico || "Não informado",
            Rotas:
              item.rotas && item.rotas.length > 0
                ? item.rotas.map((r) => r.nome).join(", ")
                : "Sem rotas",
          }));

          // Criar e baixar arquivo Excel
          self.downloadExcel(
            jsonData,
            `Unidades_${new Date().toISOString().split("T")[0]}`
          );
        })
        .catch((error) => {
          self.$loading(false);
          console.error("❌ Erro na requisição:", error);
          self.$message("Erro", "Erro ao exportar arquivo", "error");
        });
    },
    downloadExcel(data, filename) {
      // Criar cabeçalho
      const headers = Object.keys(data[0]);

      // Criar linhas de dados
      const rows = data.map((row) => Object.values(row));

      // Função para limpar e formatar células com largura automática
      const formatCell = (cell, columnIndex) => {
        if (cell === null || cell === undefined) return "";

        let cellStr = String(cell).trim();

        // Calcular largura necessária baseada no conteúdo da coluna
        const header = headers[columnIndex];
        const headerLength = header ? header.length : 0;
        const cellLength = cellStr.length;

        // Usar o maior entre header e conteúdo, com padding mínimo
        const targetWidth = Math.max(headerLength, cellLength) + 2;

        // Adicionar espaços para ajustar largura se necessário
        if (cellLength < targetWidth) {
          const paddingNeeded = targetWidth - cellLength;
          const leftPadding = Math.floor(paddingNeeded / 2);
          const rightPadding = paddingNeeded - leftPadding;
          cellStr = `"${" ".repeat(leftPadding)}${cellStr}${" ".repeat(
            rightPadding
          )}"`;
        } else {
          // Se contém ponto e vírgula ou aspas, colocar entre aspas
          if (cellStr.includes(";") || cellStr.includes('"')) {
            cellStr = `"${cellStr.replace(/"/g, '""')}"`;
          }
        }

        return cellStr;
      };

      // Usar ponto e vírgula (padrão brasileiro do Excel)
      const separator = ";";

      // Criar CSV limpo
      let csvContent = "";

      // Adicionar cabeçalho
      csvContent +=
        headers.map((header) => formatCell(header)).join(separator) + "\r\n";

      // Adicionar dados
      rows.forEach((row) => {
        const formattedRow = row.map((cell, index) => {
          return formatCell(cell, index);
        });
        csvContent += formattedRow.join(separator) + "\r\n";
      });

      // Criar arquivo XLS (Excel nativo) com BOM UTF-8
      const blob = new Blob(["\ufeff" + csvContent], {
        type: "application/vnd.ms-excel;charset=utf-8;",
      });

      // Fazer download como .xls (Excel nativo)
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${filename}.xls`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      this.$message(
        "Sucesso",
        `Arquivo exportado com ${data.length} registros!`,
        "success"
      );
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>